import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { OidcAuthGuard } from 'ngx-mat-esign360';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./transaction-builder/transaction-builder.module').then(
        (m) => m.TransactionBuilderModule
      ),
    canActivate: [OidcAuthGuard],
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
